<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <button type="button" class="btn btn-sm btn-danger" @click="cerrar"><i
                        class="fas fa-times"></i></button>
            </div>

            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h3>
                            Generar Venta
                        </h3>
                    </div>

                    <!--AQUI -->
                    <div class="col-sm-6 mt-3">
                        <button type="button"
                            :class="['btn', 'btn-lg', 'btn-block', tipo_documento === 'facturas' ? 'btn-success' : 'btn-outline-dark']"
                            @click="seleccionar_tipo_documento('facturas')"><i class="fas fa-file-invoice"></i>
                            Facturas</button>
                    </div>
                    <div class="col-sm-6 mt-3">
                        <button type="button"
                            :class="['btn', 'btn-lg', 'btn-block', tipo_documento === 'recibos' ? 'btn-primary' : 'btn-outline-dark']"
                            @click="seleccionar_tipo_documento('recibos')"><i class="fas fa-receipt"></i>
                            Recibos</button>
                    </div>
                    <div class="col-sm-12 mt-3">
                        <label for="comentarios" class="form-label">Comentarios</label>
                        <textarea id="comentarios" class="form-control form-control-sm"
                            v-model="comentarios"></textarea>
                    </div>

                    <div class="col-sm-12 mt-3 mb-3">
                        <button type="button" class="btn btn-sm btn-outline-dark btn-block" @click="guardar_registro"><i
                                class="fas fa-save"></i>
                            Guardar</button>
                    </div>

                </b-row>
            </b-container>
        </div>
        <Cargando v-if="loading_certificando" :titulo="'Certificando...'" />
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex'
    import { minix } from '@/components/functions/alertas'
    import Cargando from '@/components/Loading/Cargando.vue'

    import pdfMake from 'pdfmake/build/pdfmake.js'
    import pdfFonts from 'pdfmake/build/vfs_fonts.js'
    pdfMake.addVirtualFileSystem(pdfFonts);

    export default {
        name: 'GenerarVenta',
        components: {
            Cargando
        },
        computed: {
            ...mapState(['datos_usuario', 'id_empresa_seleccionada', 'datos_cliente', 'datos_anticipo_modal', 'datos_anticipo_completo', 'nombre_empresa_seleccionada'])
        },
        data() {
            return {
                tipo_documento: '',
                activar_siguiente_paso: false,
                comentarios: '',
                loading_certificando: false,
                datos_certificacion: {}
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            seleccionar_tipo_documento(tipo) {
                this.tipo_documento = tipo
                this.activar_siguiente_paso = true
            },
            async ejecutar_factura(dif_efectivo, dif_tarjeta, tipo_de_pago) {
                if (this.datos_anticipo_completo.capital[0].completo) {
                    minix({ icon: 'info', mensaje: 'El anticipo ya fue completado', tiempo: 3000 })
                    return
                }

                let f = {
                    api: `movimientos-cabeceras/g/ventas`,
                    formulario: {
                        total_movimiento: this.datos_anticipo_completo.capital[0].monto,
                        dif_efectivo,
                        dif_tarjeta,
                        sucursal: this.datos_usuario.sucursal_asignada,
                        listado: this.datos_anticipo_completo.capital[0].carrito,
                        vendedor: this.datos_usuario.id,
                        nit_cliente: this.datos_anticipo_completo.capital[0].datos_cliente.nit,
                        nombre_cliente: this.datos_anticipo_completo.capital[0].datos_cliente.nombre_cliente,
                        tipo_de_pago,
                        no_autorizacion: this.datos_anticipo_completo.capital[0].correlativo_anticipo
                    }
                }

                this.loading_certificando = true
                let r = await this.guardar_data(f)
                this.loading_certificando = false


                if (r.tipo_de_respuesta == 'certificado') {
                    this.datos_certificacion = r

                    let f = {
                        api: `anticipos/${this.datos_anticipo_completo.capital[0].documentId}`,
                        formulario: {
                            completo: true,
                            comentarios: this.comentarios
                        }
                    }

                    await this.actualizar_data(f)

                    await this.generar_ticket_factura()

                    this.$emit('anticipo_completo')
                    this.cerrar()
                } else {
                    this.datos_certificacion = r
                    this.abrir_modal_contingencia()
                }
            },
            async ejecutar_recibo(dif_efectivo, dif_tarjeta, tipo_de_pago) {

                let f = {
                    api: `movimientos-cabeceras/g/recibo`,
                    formulario: {
                        total_movimiento: this.datos_anticipo_completo.capital[0].monto,
                        sucursal: this.datos_usuario.sucursal_asignada,
                        listado: this.datos_anticipo_completo.capital[0].carrito,
                        vendedor: this.datos_usuario.id,
                        nit_cliente: this.datos_anticipo_completo.capital[0].datos_cliente.nit,
                        nombre_cliente: this.datos_anticipo_completo.capital[0].datos_cliente.nombre_cliente,
                        tipo_de_pago,
                        no_autorizacion: this.datos_anticipo_completo.capital[0].correlativo_anticipo,
                        dif_efectivo,
                        dif_tarjeta
                    }
                }

                let r = await this.guardar_data(f)

                let fx = {
                    api: `anticipos/${this.datos_anticipo_completo.capital[0].documentId}`,
                    formulario: {
                        completo: true,
                        comentarios: this.comentarios
                    }
                }

                await this.actualizar_data(fx)

                await this.generar_ticket_recibo(r)

                this.$emit('anticipo_completo')
                this.cerrar()


            },
            async guardar_registro() {
                if (this.tipo_documento == '') {
                    minix({ icon: 'info', mensaje: 'Elige un tipo de documento', tiempo: 3000 })
                    return
                }

                if (this.comentarios.trim() == '') {
                    minix({ icon: 'info', mensaje: 'Ingresa los comentarios', tiempo: 3000 })
                    return
                }

                let dif_efectivo = 0
                let dif_tarjeta = 0

                for (let i = 0; i < this.datos_anticipo_completo.anticipos.length; i++) {
                    let e = this.datos_anticipo_completo.anticipos[i]

                    if (e.tipo_pago.toUpperCase() == 'EFECTIVO') {
                        dif_efectivo += e.monto
                    } else if (e.tipo_pago.toUpperCase() == 'TARJETA') {
                        dif_tarjeta += e.monto
                    } else {
                        dif_efectivo += e.dif_efectivo
                        dif_tarjeta += e.dif_tarjeta
                    }

                }

                let tp = dif_efectivo == 0 ? 'TARJETA' : dif_tarjeta == 0 ? 'EFECTIVO' : 'AMBOS'

                if (this.tipo_documento == 'facturas') {
                    await this.ejecutar_factura(dif_efectivo, dif_tarjeta, tp)
                } else {
                    await this.ejecutar_recibo(dif_efectivo, dif_tarjeta, tp)
                }

            },
            abrir_modal_contingencia() { },
            async generar_ticket_factura() {
                const docDefinition = {
                    pageSize: {
                        width: 226.77, // 80mm en puntos (1mm = 2.83465 puntos)
                        height: 'auto'
                    },
                    pageMargins: [5, 5, 5, 5], // Márgenes mínimos para impresora térmica
                    content: [
                        {
                            text: this.nombre_empresa_seleccionada,
                            style: 'header',
                            alignment: 'center'
                        },
                        {
                            text: this.datos_certificacion.datos_cert.datos_sucursal.nombre_propietario,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: this.datos_certificacion.datos_cert.datos_sucursal.direccion,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: this.datos_certificacion.datos_cert.datos_sucursal.establecimiento,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: `NIT: ${this.datos_certificacion.datos_cert.datos_sucursal.nit}`,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: 'SUJETO A PAGOS TRIMESTRALES ISR.',
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: '----------------------------------------',
                            alignment: 'center'
                        },
                        {
                            text: this.datos_certificacion.datos_cert.datos_sucursal.establecimiento,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: `NIT: ${this.datos_certificacion.datos_cert.datos_cliente.nit}`,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: `CLI: ${this.datos_certificacion.datos_cert.datos_cliente.nombre}`,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: 'DIR: CIUDAD',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        {
                            columns: [
                                { text: 'DESCRIPCION', style: 'tableHeader', width: '58%' },
                                { text: 'CANT.', style: 'tableHeader', width: '20%' },
                                { text: 'MONTO', style: 'tableHeader', width: '22%' }
                            ]
                        },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        {
                            columns: [
                                { text: 'Descuento', style: 'total_2', width: '70%' },
                                {
                                    text: this.datos_certificacion.datos_cert.datos_venta.tipo_de_pago == 'tarjeta' ? "Q.0.00" : `Q${(this.datos_certificacion.datos_cert.datos_venta.total_descuentos).toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    })}`, style: 'cantidad_total_2', width: '30%'
                                }
                            ]
                        },
                        {
                            columns: [
                                { text: 'Total', style: 'total', width: '70%' },
                                {
                                    text: `Q${this.datos_certificacion.datos_cert.datos_venta.total_movimiento.toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    })}`, style: 'cantidad_total', width: '30%'
                                }
                            ]
                        },
                        {
                            text: 'Documento Tributario Electrónico',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '** Factura **',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: this.datos_certificacion.datos_cert.Serie,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: 'NÚMERO DE AUTORIZACIÓN:',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: this.datos_certificacion.datos_cert.Autorizacion,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: `CERTIFICACIÓN: ${this.datos_certificacion.datos_cert.Fecha_de_certificacion}`,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '',
                            style: 'espacio',
                            alignment: 'center'
                        },
                        {
                            text: 'CERTIFICADOR NIT: 77454820',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: 'DIGIFACT SERVICIOS',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: 'SOCIEDAD ANONIMA',
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '',
                            style: 'espacio',
                            alignment: 'center'
                        },
                        {
                            text: 'Gracias por su compra',
                            bold: true,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '**',
                            style: 'pie_ticket',
                            alignment: 'center'
                        }
                    ],
                    styles: {
                        header: {
                            fontSize: 11,
                            bold: true,
                            margin: [0, 20, 0, 5]
                        },
                        subheader: {
                            fontSize: 10,
                            margin: [0, 0, 0, 3]
                        },
                        normal: {
                            fontSize: 10,
                            margin: [0, 0, 0, 3]
                        },
                        separador: {
                            fontSize: 11,
                            margin: [0, -5, 0, 0]
                        },
                        tableHeader: {
                            fontSize: 10,
                            bold: true,
                            margin: [6, -5, 5, 0]
                        },
                        descripcion: {
                            fontSize: 9,
                            margin: [6, 0, 0, 0]
                        },
                        cantidad: {
                            fontSize: 9,
                            margin: [30, 0, 0, 0]
                        },
                        monto: {
                            fontSize: 9,
                            margin: [15, 0, 0, 0]
                        },
                        total: {
                            fontSize: 9,
                            bold: true,
                            margin: [130, 0, 0, 20]
                        },
                        total_2: {
                            fontSize: 9,
                            bold: true,
                            margin: [105, 0, 0, 0]
                        },
                        cantidad_total: {
                            fontSize: 9,
                            margin: [15, 0, 0, 20]
                        },
                        cantidad_total_2: {
                            fontSize: 9,
                            margin: [15, 0, 0, 0]
                        },
                        espacio: {
                            fontSize: 10,
                            margin: [0, 0, 0, 10]
                        },
                        pie_ticket: {
                            fontSize: 10,
                            margin: [0, 50, 0, 0]
                        }
                    }
                };

                // Insertando de manera dinamica los productos
                let posicion_a_insertar = 14

                for (let i = 0; i < this.datos_certificacion.datos_cert.datos_venta.listado.length; i++) {
                    const e = this.datos_certificacion.datos_cert.datos_venta.listado[i];

                    docDefinition.content.splice(posicion_a_insertar, 0, {
                        columns: [
                            { text: e.nombre, style: 'descripcion', width: '50%' },
                            { text: e.cantidad, style: 'cantidad', width: '20%' },
                            {
                                text: `Q${(e.precio_tarjeta * e.cantidad).toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                })}`, style: 'monto', width: '30%'
                            }
                        ]
                    })

                    posicion_a_insertar++
                }

                // Crear y descargar el PDF
                pdfMake.createPdf(docDefinition).print();
            },
            async generar_ticket_recibo(r) {
                const docDefinition = {
                    pageSize: {
                        width: 226.77, // 80mm en puntos (1mm = 2.83465 puntos)
                        height: 'auto'
                    },
                    pageMargins: [5, 5, 5, 5], // Márgenes mínimos para impresora térmica
                    content: [
                        {
                            text: this.nombre_empresa_seleccionada,
                            style: 'header',
                            alignment: 'center'
                        },
                        {
                            text: r.establecimiento,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: r.direccion,
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: '----------------------------------------',
                            alignment: 'center'
                        },
                        {
                            text: '*** RECIBO ***',
                            style: 'subheader',
                            alignment: 'center'
                        },
                        {
                            text: `NIT: ${this.datos_anticipo_completo.capital[0].datos_cliente.nit}`,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: `CLI: ${this.datos_anticipo_completo.capital[0].datos_cliente.nombre_cliente}`,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        {
                            columns: [
                                { text: 'DESCRIPCION', style: 'tableHeader', width: '58%' },
                                { text: 'CANT.', style: 'tableHeader', width: '20%' },
                                { text: 'MONTO', style: 'tableHeader', width: '22%' }
                            ]
                        },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        {
                            text: '-------------------------------------------------------------------',
                            style: 'separador',
                            alignment: 'center'
                        },
                        {
                            columns: [
                                { text: 'Descuento', style: 'total_2', width: '70%' },
                                {
                                    text: `Q${r.datos_ventas.total_descuentos.toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    })}`, style: 'cantidad_total_2', width: '30%'
                                }
                            ]
                        },
                        {
                            columns: [
                                { text: 'Total', style: 'total', width: '70%' },
                                {
                                    text: `Q${r.datos_ventas.total_movimiento.toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    })}`, style: 'cantidad_total', width: '30%'
                                }
                            ]
                        },
                        {
                            text: '',
                            style: 'espacio',
                            alignment: 'center'
                        },
                        {
                            text: '',
                            style: 'espacio',
                            alignment: 'center'
                        },
                        {
                            text: 'Gracias por su compra',
                            bold: true,
                            style: 'normal',
                            alignment: 'center'
                        },
                        {
                            text: '**',
                            style: 'pie_ticket',
                            alignment: 'center'
                        }
                    ],
                    styles: {
                        header: {
                            fontSize: 11,
                            bold: true,
                            margin: [0, 20, 0, 5]
                        },
                        subheader: {
                            fontSize: 10,
                            margin: [0, 0, 0, 3]
                        },
                        normal: {
                            fontSize: 10,
                            margin: [0, 0, 0, 3]
                        },
                        separador: {
                            fontSize: 11,
                            margin: [0, -5, 0, 0]
                        },
                        tableHeader: {
                            fontSize: 10,
                            bold: true,
                            margin: [6, -5, 5, 0]
                        },
                        descripcion: {
                            fontSize: 9,
                            margin: [6, 0, 0, 0]
                        },
                        cantidad: {
                            fontSize: 9,
                            margin: [30, 0, 0, 0]
                        },
                        monto: {
                            fontSize: 9,
                            margin: [15, 0, 0, 0]
                        },
                        total: {
                            fontSize: 9,
                            bold: true,
                            margin: [130, 0, 0, 20]
                        },
                        total_2: {
                            fontSize: 9,
                            bold: true,
                            margin: [105, 0, 0, 0]
                        },
                        cantidad_total: {
                            fontSize: 9,
                            margin: [15, 0, 0, 20]
                        },
                        cantidad_total_2: {
                            fontSize: 9,
                            margin: [15, 0, 0, 0]
                        },
                        espacio: {
                            fontSize: 10,
                            margin: [0, 0, 0, 10]
                        },
                        pie_ticket: {
                            fontSize: 10,
                            margin: [0, 50, 0, 0]
                        }
                    }
                };

                // Insertando de manera dinamica los productos
                let posicion_a_insertar = 10

                for (let i = 0; i < this.datos_anticipo_completo.capital[0].carrito.length; i++) {
                    const e = this.datos_anticipo_completo.capital[0].carrito[i];

                    docDefinition.content.splice(posicion_a_insertar, 0, {
                        columns: [
                            { text: e.nombre, style: 'descripcion', width: '50%' },
                            { text: e.cantidad, style: 'cantidad', width: '20%' },
                            {
                                text: `Q${(e.precio_tarjeta * e.cantidad).toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                })}`, style: 'monto', width: '30%'
                            }
                        ]
                    })

                    posicion_a_insertar++
                }

                // Crear y descargar el PDF
                pdfMake.createPdf(docDefinition).print();
            },
            ...mapActions(['guardar_data', 'obtener_data', 'actualizar_data'])
        },
    }
</script>

<style></style>